<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    .content.exhibitions(v-if='!loading')
      .grid
        .col-12.no-bottom
          h1.category.h-xl
            | exhibitions
          h2#current.h-l
            | on view
        .col-12
          .screen(v-if='!loading')
            router-link(:to="{name: 'exhibition-single', params: {year: startYear(current.main), id: current.main.uid }}")
              .screen-image
                img.cover(:src="current.main.image" :alt="altText")
                .captions-main
                  //- h2.title.h-xl
                  //-   | exhibition
                  h2.h-xl.italic
                    | {{ title(current.main) }}
                  h2.h-l
                    | {{ displayDate(current.main) }}
        .col-6_xs-12(v-for="exhibition in current.exhibitions")
          .screen(v-if='!loading', :key="title(exhibition)")
            router-link(:to="{name: 'exhibition-single', params: {year: startYear(exhibition), id: exhibition.uid }}")
              .screen-image
                img.cover(:src="exhibition.image" :alt="exhibition.title")
                .captions
                  //- h2.title.h-l
                  //-   | exhibition
                  h2.h-xl.italic
                    | {{ title(exhibition) }}
                  h2.h-l
                    | {{ displayDate(exhibition) }}
      .grid#further-exhibitions
        .col-6_xs-12
          h2#upcoming.h-l
            | upcoming
          .half-screen(v-if='!loading')
            router-link(
              :to="{name: 'exhibitions-overview', params: {year: 'upcoming'}}"
            )
              .screen-image
                img.cover(:src="upcomingFeatured" alt="Upcoming Exhibitions")
        .col-6_xs-12(v-if='traveling.image')
          h2#traveling.h-l
            | traveling
          .half-screen(v-if='!loading')
            router-link(
              :to="{name: 'exhibitions-overview', params: {year: 'traveling'}}"
            )
              .screen-image
                img.cover(:src="travelingFeatured" alt="Traveling Exhibitions")
        .col-6_xs-12
          h2#past.h-l
            | past
          .half-screen(v-if='!loading')
            router-link(
              :to="{name: 'exhibitions-overview', params: {year: 'past'}}"
            )
              .screen-image
                img.cover(:src="pastFeatured" alt="Past Exhibitions")
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'exhibitions',
  mixins: [DataMixin, ComponentMixin],

  created () {
    this.loading = false
    this.requestData('exhibitions', 'exhibitions')
  },

  methods: {
    startDate: function (exhibition) {
      return exhibition.content.start_date
    },

    endDate: function (exhibition) {
      return exhibition.content.end_date
    },

    startYear: function (exhibition) {
      return exhibition.content.start_year
    },

    endYear: function (exhibition) {
      return exhibition.content.end_year
    },

    date: function (exhibition) {
      const endDate = this.endDate(exhibition) + ', ' + this.endYear(exhibition)
      let startDate = this.startDate(exhibition)
      if (this.endYear(exhibition) !== this.startYear(exhibition)) {
        startDate = this.startDate(exhibition) + ', ' + this.startYear(exhibition)
      }
      return startDate + ' - ' + endDate
    },

    /* eslint-disable */
    displayDate: function (exhibition) {
      const dd = exhibition.content.display_date
      return !!dd ? dd : this.date(exhibition)
    },
    /* eslint-enable */

    title: function (exhibition) {
      return exhibition.content.title
    }
  },

  computed: {
    current: function () {
      const data = this.loadedData.exhibitions.current
      const main = data.splice(0, 1)[0]
      const current = {
        main,
        exhibitions: data
      }
      return current
    },

    traveling: function () {
      if (this.loadedData.exhibitions.traveling.length === 0) {
        return false
      } else {
        return this.loadedData.exhibitions.traveling
      }
    },

    upcoming: function () {
      return this.loadedData.exhibitions.upcoming
    },

    upcomingHero: function () {
      if (this.upcoming.length > 0) {
        return this.upcoming[0].image
      } else {
        return false
      }
    },

    past: function () {
      return this.loadedData.exhibitions.past
    },

    key: function () {
      return 'exhibitions'
    },

    pastFeatured: function () {
      return this.loadedData.exhibitions.past_featured
    },

    travelingFeatured: function () {
      return this.loadedData.exhibitions.traveling_featured
    },

    upcomingFeatured: function () {
      return this.loadedData.exhibitions.upcoming_featured
    },

    altText: function () {
      return this.current.main.title
    }
  },

  watch: {
    $route: function () {
      if (this.$route.query.status === 'past') {
        this.$router.replace({name: 'exhibitions-overview', params: {year: 'past'}})
      } else if (this.$route.query.status === 'traveling') {
        this.$router.replace({name: 'exhibitions-overview', params: {year: 'traveling'}})
      } else if (this.$route.query.status === 'future') {
        if (!this.loading) {
          document.getElementById('future').scrollIntoView()
          window.scrollBy(0, -150)
        }
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    if (to.query.status === 'past') {
      next(vm => {
        vm.$router.replace({name: 'exhibitions-overview', params: {year: 'past'}})
      })
    } else if (to.query.status === 'traveling') {
      next(vm => {
        vm.$router.replace({name: 'exhibitions-overview', params: {year: 'traveling'}})
      })
    } else if (to.query.status === 'future') {
      next(vm => {
        if (!vm.loading) {
          document.getElementById('future').scrollIntoView()
          window.scrollBy(0, -150)
        }
      })
    }
    next()
  }
}
</script>

<style lang="sass">
@import '../styles/_variables'
@import '../styles/_mixins'
.exhibitions
  margin-top: $paddingTop
  @include respond-to(xs)
    margin-top: 1rem
  #upcoming, #past, #traveling
    margin: 9rem 0 3rem 0
    @include respond-to(xs)
      margin: 0 0 1rem 0
  .category
    color: $exhibitions
    @include respond-to(xs)
      margin-bottom: 2rem
  .no-bottom
    @include respond-to(xs)
      padding-bottom: 0
  .screen
    width: 100%
    height: 76.5vH
    position: relative
    @include respond-to(xs)
      height: 53.5vw !important
      height: 0
    .screen-image
      width: 100%
      height: 76.5vH
      position: relative
      @include respond-to(xs)
        width: 100%
        height: 53.5vw
      &:hover .captions
        opacity: 1
        @include transition(opacity, 0.2s, ease-in-out)
      &:hover
        .captions-main
          opacity: 1
          @include transition(opacity, 0.2s, ease-in-out)
    .captions-main
      opacity: 0
      width: calc(100% - 3.81vw)
      height: unset
      color: #FFF
      background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.9))
      padding: 13vw 0 3.81vw 3.81vw
      position: absolute
      bottom: 0
      @include respond-to(xs)
        height: calc(53.5vw - 3.81vw)
        padding: 0 0 3.81vw 3.81vw
        opacity: 1
        h2
          position: absolute
          bottom: 0
          &:nth-of-type(1)
            padding: 0 0 calc(3.81vw + 3rem) 0
          &:nth-of-type(2)
            padding: 0 0 3.81vw 0
      >*
        padding-right: 3.81vW
      .title
        display: block
        @include respond-to(xs)
          display: none
    .captions
      width: 100%
      height: 76.5vh
      background-color: rgba(255, 255, 255, 0.9)
      opacity: 0
      position: absolute
      bottom: 0
      @include transition(opacity, 0.2s, ease-in-out)
      @include respond-to(xs)
        height: 53.5vw
        opacity: 1
        color: #FFF
        background: linear-gradient(hsla(0,0%,100%,0),rgba(0,0,0,.9))
      h2
        position: absolute
        bottom: 0
        &:nth-of-type(1)
          padding: 0 0 $paddingTop 3.3rem
          @include respond-to(xs)
            padding: 0 0 calc(3.81vw + 3rem) 3.81vw
        &:nth-of-type(2)
          padding: 0 0 3.3rem 3.3rem
          @include respond-to(xs)
            padding: 0 0 3.81vw 3.81vw
      >*
        padding-right: 3.81vW
      .title
        display: block
        @include respond-to(xs)
          display: none
  .gallery-desktop
    .captions
      position: absolute
      bottom: 0
      width: 78.79vW
      color: #FFF
      padding-left: 3.81vW
      background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.75))
  .half-screen
    width: 100%
    height: 76.5vH
    @include respond-to(xs)
      padding-bottom: 58%
      height: 0
    .screen-image
      width: 100%
      height: 76.5vH
      @include respond-to(xs)
        width: 100%
        height: 53.5vw
</style>



// WEBPACK FOOTER //
// Exhibitions.vue?62c0af8e